import { getAttribute } from "../../../../../../../../../../utils/utils/get-line-item-attribute.js";
import { getLocalizedAttribute } from "../../../../../../../../../../utils/utils/get-line-item-localized-attribute.js";
import { getBundledLineItemProductVariant } from "../../../../../../bundles/mappers/view/line-item/utils/bundles/get-bundled-line-item-product-variant.js";
import { getBundledProductInfo } from "./get-bundled-product-info.js";
function getBundledFrameInfo(lineItemRaw, bundleLineItem, intl) {
  const variant = getBundledLineItemProductVariant(bundleLineItem);
  const brandName = getAttribute(variant, "brand");
  const model = getAttribute(variant, "brandModel");
  const modelCode = getAttribute(variant, "brandModelCode");
  const modelColorCode = getAttribute(variant, "brandModelColorCode");
  const gender = getLocalizedAttribute(variant, "gender", intl.locale);
  const frameColor = getLocalizedAttribute(variant, "frameColor", intl.locale);
  const frameShape = getLocalizedAttribute(variant, "frameShape", intl.locale);
  const frameMaterial = getLocalizedAttribute(variant, "frameMaterial", intl.locale);
  const faceShape = getLocalizedAttribute(variant, "faceShape", "en");
  const frameType = getLocalizedAttribute(variant, "frameType", "en");
  const title = [...new Set([brandName, model, modelCode, modelColorCode].filter(Boolean))].join(
    " "
  );
  return {
    ...getBundledProductInfo(bundleLineItem, intl),
    title,
    productId: lineItemRaw.id,
    brand: {
      name: brandName,
      model,
      modelCode
    },
    gender,
    frameType,
    faceShape,
    frameColor,
    frameShape,
    frameMaterial
  };
}
export {
  getBundledFrameInfo
};
//# sourceMappingURL=get-bundled-frame-info.js.map
